import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnnouncementDetails } from '../../../../../../shared/models/announcement-details';
import { AnnouncementEditFormModel } from './announcement-edit-form.model';

export class AnnouncementEditFormBuilder {
  static createFormGroup(
    announcement: AnnouncementDetails,
  ): FormGroup<AnnouncementEditFormModel> {
    return new FormGroup<AnnouncementEditFormModel>({
      id: new FormControl(
        { value: announcement.id, disabled: true },
        Validators.required,
      ),
      createdAt: new FormControl(
        {
          value: announcement?.createdAt ? new Date(announcement.createdAt) : null,
          disabled: true,
        },
        Validators.required,
      ),
      title: new FormControl(announcement.title ?? null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      content: new FormControl(announcement.content ?? null, [
        Validators.required,
      ]),
      status: new FormControl(
        {
          value: announcement.status ?? null,
          disabled: true,
        },
        Validators.required,
      ),
      channel: new FormControl(announcement.channel ?? null, [
        Validators.required,
      ]),
      requiresConfirmation: new FormControl(
        announcement.requiresConfirmation ?? null,
      ),
      startDate: new FormControl(
        announcement?.startDate ? new Date(announcement.startDate) : null,
      ),
      endDate: new FormControl(
        announcement?.endDate ? new Date(announcement.endDate) : null,
      ),
      plannedEmailSendAt: new FormControl(
        announcement?.plannedEmailSendAt ? new Date(announcement.plannedEmailSendAt) : null,
      ),
      recipientType: new FormControl(announcement.recipientType ?? null, [
        Validators.required,
      ]),
      recipients: new FormControl(announcement.recipients ?? null),
      requestCode: new FormControl(announcement.requestCode ?? null),
      createdBy: new FormControl(
        {
          value: announcement.createdBy ?? null,
          disabled: true,
        },
        Validators.required,
      ),
      publishedAt: new FormControl({
        value: announcement?.publishedAt ? new Date(announcement.publishedAt) : null,
        disabled: true,
      }),
    });
  }
}
